import React, { useState } from "react";
import {Link, useParams} from 'react-router-dom';
import {MAIL_ACCOUNT_ALL_LINK} from "../../constants/constants";
import FormValidator from "../../FormValidator";
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import client from "../../api";
import { notifyError, notifySuccess } from "../../helper";

const CreateGoogleSmtpAccount = () => {
    const {emailID} = useParams('');
    const api = client();
    const [data,setData] = useState({
        smtphostname:'',
        smtpportnumber:'',
        smtpusername:'',
        smtppassword:''        
    });
    const [loading,setLoading] = useState(false);

    const validatorRules = {
        email: {
            rule1:{
                message: "Please Enter a valid Email Address.",
                validator: (val) => !(/\S+@\S+\.\S+/.test(val))
            }
        },
        fullname: {
            empty:"Please Enter Full Name"
        },
        smtphostname:{
            rule1:{
                message: "Please Enter a Valid SMTP Host Name.",
                validator: (val) => !((/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+/).test(val))
            },
            // rule2:{
            //     message: "Gmail domain is not allowed.",
            //     validator: (val) => !((/^(?!([a-z0-9._-]+\.)?gmail\.com$).+$/i).test(val))
            // }
        },
        smtpportnumber:{
            empty:"Please Enter SMTP Port Number."
        },
        smtpusername:{
            empty:"Please Enter SMTP Username."
        },
        smtppassword:{
            empty:"Please Enter SMTP Password."
        }
    }

    const prepareData = (input) => {
        setData({...data,...input});    
    }
    
    const validatorObject = new FormValidator(validatorRules);
    const [error, setError] = useState({});

    const removeError = (e) => {
        setError({ ...error, [e.target.name]: "" });
    }

    const fieldBlur = e => {
        const fieldError = validatorObject.validateFields(e.target.value, e.target.name)
        if (Object.keys(fieldError).length) setError({ ...error, ...fieldError });        
    }

    const fieldFocus = e => {
        removeError(e);
        //update()
    }

    const validateAllFields = (inputs) => {
        const v = validatorObject.validateFields(inputs);
        if(Object.keys(v).length === 0){
            return true;
        } else {
            setError({...v});
            return false;
        }       
    }

    const rearrangeData = (inputValues) => {
        return {
            "id": emailID,
            "smtp": {
                "server": inputValues.smtphostname,
                "port": inputValues.smtpportnumber,
                "username": inputValues.smtpusername,
                "password": inputValues.smtppassword
            }            
        }
    }

    const createGoogleSmtpAccount = async() => {
        try{
            setLoading(true);
            if(emailID.length && validateAllFields(data)){
                const payload = rearrangeData(data);
                const response = await api.post("/v1/mailAccount/google-smtp/update", payload);
                if(response.status === 200 || response.status === 201){
                    notifySuccess('Google SMTP account updated successfully');
                    setTimeout(()=>{
                        window.location.href = MAIL_ACCOUNT_ALL_LINK;
                    },1200);
                }
            }
        } catch(error){
            setLoading(false);
            if(error.status === 400){
                notifyError("Bad Request. Unable to create Google SMTP account. Please try again.");
            }
        } finally{
            setLoading(false);
        }
    }

    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
            <div className="mailaccounts-pages-wrap">
                <div className="top-section">
                    <h1>Add SMTP Connection for Google account</h1>
                    <div className="button-group">
                        <Link to={MAIL_ACCOUNT_ALL_LINK} className="primary-btn"><i className="bx bx-list-ul"></i> All  Mail Accounts</Link>
                    </div>
                </div>
                <div className="create-mailaccount-wrap">
                    <div className="mail-create-form">
                        <form onSubmit={(e)=>{e.preventDefault();}} encType="multipart/form-data" method="post">
                            <div className="form-content">
                                <h3>Add SMTP connection</h3>
                                <p>This information comes from your email provider and is how we'll send your emails.</p>
                            </div>
                            <div className="form-group">
                                <div className="column-2-inner">
                                    <div className="field-wrap col-1">
                                        <label className="label-xs">Host (e.g. mail.server.com)</label>
                                        <input 
                                            type="text" 
                                            name="smtphostname" 
                                            placeholder="Host Name" 
                                            value={data?.smtphostname ? data.smtphostname:''}
                                            onChange={(e)=>{
                                                prepareData({"smtphostname": e.target.value});
                                            }} 
                                            onBlur={(e)=>{
                                                fieldBlur(e);
                                            }}
                                            onFocus={(e) =>{
                                                fieldFocus(e)
                                            }}
                                            />
                                            {error.smtphostname && <span className="validation-error">{error.smtphostname}</span>}
                                    </div>
                                    <div className="field-wrap col-2">
                                        <label className="label-xs">Port number</label>
                                        <select
                                            name="smtpportnumber" 
                                            className="selectbox" 
                                            onChange={(e)=>{
                                                prepareData({'smtpportnumber':e.target.value});
                                            }}
                                            onFocus={(e)=>{
                                                fieldFocus(e);
                                            }}
                                            onBlur={(e)=>{
                                                fieldBlur(e);
                                            }}
                                            >
                                                <option value={''}>Port</option>
                                                <option value={25}>25</option>
                                                <option value={465}>465</option>
                                                <option value={587}>587</option>
                                                <option value={2525}>2525</option>
                                        </select>
                                        {error.smtpportnumber && <span className="validation-error">{error.smtpportnumber}</span>}                                
                                    </div>
                                </div>
                            
                                <div className="field-wrap">
                                    <label className="label-xs">Username (usually your email address)</label>
                                    <input 
                                        type="text" 
                                        name="smtpusername" 
                                        placeholder="Username"
                                        value={data?.smtpusername ? data.smtpusername:''}
                                        onChange={(e)=>{
                                            prepareData({"smtpusername": e.target.value});
                                        }} 
                                        onBlur={(e)=>{
                                            fieldBlur(e);
                                        }}
                                        onFocus={(e) =>{
                                            fieldFocus(e)
                                        }}
                                        />
                                        {error.smtpusername && <span className="validation-error">{error.smtpusername}</span>}
                                </div>

                                <div className="field-wrap">
                                    <label className="label-xs">Password</label>
                                    <input 
                                        type="password" 
                                        name="smtppassword" 
                                        placeholder="*****"
                                        value={data?.smtppassword ? data.smtppassword:''}
                                        onChange={(e)=>{
                                            prepareData({"smtppassword": e.target.value});
                                        }}  
                                        onBlur={(e)=>{
                                            fieldBlur(e);
                                        }}
                                        onFocus={(e) =>{
                                            fieldFocus(e)
                                        }}
                                        />
                                        {error.smtppassword && <span className="validation-error">{error.smtppassword}</span>}
                                </div>
                            </div>
                            <div className="field-wrap form-btn">
                                <button 
                                className={loading ? "primary-btn button--loading":"primary-btn"} 
                                disabled={loading}
                                onClick={()=>{
                                    createGoogleSmtpAccount()
                                }}><span className="button--text">Save</span></button>
                                <button className="back-btn" onClick={()=>{
                                    window.location.href= MAIL_ACCOUNT_ALL_LINK;
                                }}>Back</button>
                            </div>
                        </form>                        
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </>);
}

export default CreateGoogleSmtpAccount;